/* ============================================================================
   SHOPOMAN LUXURY — theme.js
   Drawers, mega menu, predictive search, ajax cart, variants, sliders,
   countdowns, tabs, accordions, filters. Vanilla JS, no dependencies.
   ============================================================================ */
(function () {
  'use strict';

  var doc = document;
  var $ = function (sel, ctx) { return (ctx || doc).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); };

  /* ------------------------------ Utilities ------------------------------- */

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = parseInt(cents, 10);
    if (isNaN(value)) return '';
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var number = value / 100;
    var amount;
    if (fmt.indexOf('amount_no_decimals') !== -1) {
      amount = String(Math.round(number));
    } else {
      var fixed = number.toFixed(2).split('.');
      var thousands = /\B(?=(\d{3})+(?!\d))/g;
      if (fmt.indexOf('with_comma_separator') !== -1) {
        fixed[0] = fixed[0].replace(thousands, '.');
        amount = fixed.join(',');
      } else {
        fixed[0] = fixed[0].replace(thousands, ',');
        amount = fixed.join('.');
      }
    }
    return fmt.replace(/\{\{\s*amount[^\}]*\}\}/, amount);
  }

  var toastTimer;
  function toast(message, isError) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  function trapFocus(container) {
    container.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var focusables = $$('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && doc.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && doc.activeElement === last) { first.focus(); e.preventDefault(); }
    });
  }

  function tString(key, fallback) {
    var strings = window.theme && window.theme.strings;
    return (strings && strings[key]) || fallback;
  }

  /* ================= LANGUAGE SWITCHER + AUTO-DETECTION ==================== */
  (function language() {
    /* Auto-redirect Arabic devices to the Arabic locale (once per session,
       and never when the visitor already chose a language manually). */
    try {
      var locales = (window.theme && window.theme.locales) || [];
      if (locales.indexOf('ar') !== -1 && window.theme.locale !== 'ar') {
        var navLang = (navigator.language || navigator.userLanguage || '').toLowerCase();
        var chosen = localStorage.getItem('shopoman_lang');
        var redirected = sessionStorage.getItem('shopoman_lang_redirected');
        if (!chosen && !redirected && navLang.indexOf('ar') === 0) {
          sessionStorage.setItem('shopoman_lang_redirected', '1');
          var path = location.pathname.replace(/^\/ar(?=\/|$)/, '');
          if (!path) path = '/';
          location.href = '/ar' + path + location.search;
          return;
        }
      }
    } catch (e) {}

    /* Remember manual choices so auto-detection never overrides them */
    $$('[data-lang-switch]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        try { localStorage.setItem('shopoman_lang', btn.getAttribute('data-lang-switch') || ''); } catch (e) {}
      });
    });
  })();

  /* --------------------------- Header on scroll ---------------------------- */
  var header = $('[data-header]');
  function onHeaderScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onHeaderScroll, { passive: true });
  onHeaderScroll();

  /* ------------------------------ Back to top ------------------------------ */
  var backToTop = $('[data-back-to-top]');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      backToTop.classList.toggle('is-visible', window.scrollY > 600);
    }, { passive: true });
    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* -------------------------- Overlay open/close --------------------------- */
  var lastFocused = null;

  function openOverlay(root) {
    if (!root) return;
    lastFocused = doc.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    doc.body.style.overflow = 'hidden';
  }

  function closeOverlay(root) {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    doc.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  /* Mobile menu */
  var mobileNav = $('[data-mobile-nav]');
  $$('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () { openOverlay(mobileNav); });
  });
  $$('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () { closeOverlay(mobileNav); });
  });

  /* Search overlay + predictive search */
  var searchOverlay = $('[data-search-overlay]');
  $$('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openOverlay(searchOverlay);
      var input = $('[data-predictive-input]');
      if (input) setTimeout(function () { input.focus(); }, 120);
    });
  });
  $$('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', function () { closeOverlay(searchOverlay); });
  });

  (function predictiveSearch() {
    var input = $('[data-predictive-input]');
    var results = $('[data-predictive-results]');
    if (!input || !results) return;

    var controller = null;
    var debounce = null;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(debounce);
      if (q.length < 2) {
        results.innerHTML = '<p class="search-overlay__hint">' + escapeHtml(input.dataset.hint || 'Start typing to search products...') + '</p>';
        return;
      }
      debounce = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = window.theme.routes.predictiveSearch +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
        fetch(url, { signal: controller.signal })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var section = parsed.querySelector('#shopify-section-predictive-search') || parsed.body.firstElementChild;
            results.innerHTML = section ? section.innerHTML : '';
          })
          .catch(function (err) {
            if (err.name !== 'AbortError') results.innerHTML = '';
          });
      }, 250);
    });
  })();

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    [mobileNav, searchOverlay, $('[data-cart-drawer]')].forEach(closeOverlay);
    var layout = $('.collection-layout.is-filters-open');
    if (layout) layout.classList.remove('is-filters-open');
  });

  /* ------------------------------ Accordions ------------------------------- */
  function accordionContainer(trigger) {
    return trigger.closest('[data-accordion], .mobile-nav__item, .filter-group');
  }

  function setAccordionState(container, open) {
    var panel = $('[data-accordion-panel]', container);
    container.classList.toggle('is-open', open);
    if (panel) panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
  }

  $$('[data-accordion-trigger]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var container = accordionContainer(trigger);
      if (container) setAccordionState(container, !container.classList.contains('is-open'));
    });
  });

  /* Open filter groups that have active selections, else the first group */
  (function initFilters() {
    var groups = $$('.collection-filters .filter-group');
    if (!groups.length) return;
    var anyOpen = false;
    groups.forEach(function (group) {
      if ($('input:checked', group)) { setAccordionState(group, true); anyOpen = true; }
    });
    if (!anyOpen && groups[0]) setAccordionState(groups[0], true);
  })();

  /* ----------------------------- Quantity steppers ------------------------- */
  $$('[data-qty]').forEach(function (wrap) {
    var input = $('[data-qty-input]', wrap);
    if (!input) return;
    var minus = $('[data-qty-minus]', wrap);
    var plus = $('[data-qty-plus]', wrap);
    function step(dir) {
      var min = parseInt(input.min || '0', 10);
      var val = parseInt(input.value || '0', 10) + dir;
      if (val < min) val = min;
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () { step(-1); });
    if (plus) plus.addEventListener('click', function () { step(1); });
  });

  /* ============================== CART DRAWER ============================== */
  var cartDrawer = $('[data-cart-drawer]');

  function cartLineHtml(item) {
    var image = item.image
      ? '<img src="' + item.image.replace(/(\.[^.]*)$/, '_160x$1') + '" alt="' + escapeHtml(item.product_title) + '" width="76" height="90" loading="lazy">'
      : '';
    var variant = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="cart-line__variant">' + escapeHtml(item.variant_title) + '</span>'
      : '';
    var necklaceName = (item.properties && item.properties['Name on Necklace']) || '';
    var nameProp = necklaceName
      ? '<span class="cart-line__property">' + escapeHtml(tString('nameLabel', 'Name')) + ': ' + escapeHtml(necklaceName) + '</span>'
      : '';
    return '' +
      '<div class="cart-line" data-cart-line data-key="' + item.key + '">' +
        '<a class="cart-line__image" href="' + item.url + '">' + image + '</a>' +
        '<div class="cart-line__details">' +
          '<a class="cart-line__title" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' +
          variant +
          nameProp +
          '<div class="qty-selector qty-selector--sm" data-qty>' +
            '<button type="button" class="qty-selector__btn" data-qty-minus aria-label="Decrease quantity">&minus;</button>' +
            '<input class="qty-selector__input" type="number" value="' + item.quantity + '" min="0" data-qty-input aria-label="Quantity">' +
            '<button type="button" class="qty-selector__btn" data-qty-plus aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-line__aside">' +
          '<span class="cart-line__price">' + formatMoney(item.final_line_price) + '</span>' +
          '<button type="button" class="cart-line__remove" data-cart-remove aria-label="' + escapeHtml(tString('remove', 'Remove')) + '">' +
            '<svg class="icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/><path d="M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>';
  }

  function renderCart(cart) {
    /* Header count bubbles (drawer title count keeps its parentheses) */
    $$('[data-cart-count]').forEach(function (el) {
      var hasParens = el.textContent.trim().charAt(0) === '(';
      el.textContent = hasParens ? '(' + cart.item_count + ')' : cart.item_count;
      if (!hasParens) el.classList.toggle('is-empty', cart.item_count === 0);
    });

    /* Drawer body */
    var body = $('[data-cart-drawer-body]');
    if (body) {
      if (cart.item_count > 0) {
        body.innerHTML = '<ul class="cart-lines" data-cart-lines>' +
          cart.items.map(cartLineHtml).join('') + '</ul>';
      } else {
        body.innerHTML = '' +
          '<div class="cart-drawer__empty">' +
            '<div class="cart-drawer__empty-icon">' +
              '<svg class="icon" width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l1.2 13H4.8L6 7Z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>' +
            '</div>' +
            '<p class="cart-drawer__empty-title">' + escapeHtml(tString('cartEmpty', 'Your cart is currently empty')) + '</p>' +
            '<a class="btn btn--gold" href="' + window.theme.routes.allProducts + '">' + escapeHtml(tString('continueShopping', 'Continue shopping')) + '</a>' +
          '</div>';
      }
      bindCartLines(body);
    }

    /* Footer + subtotal */
    var footer = $('[data-cart-footer]');
    if (footer) footer.hidden = cart.item_count === 0;
    var subtotal = $('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.items_subtotal_price);

    /* Free shipping progress */
    var ship = $('[data-free-shipping]');
    if (ship) {
      var threshold = parseInt(ship.dataset.threshold, 10);
      var bar = $('[data-free-shipping-bar]', ship);
      var msg = $('[data-free-shipping-msg]', ship);
      if (threshold > 0 && bar && msg) {
        var pct = Math.min(100, Math.round(cart.items_subtotal_price / threshold * 100));
        bar.style.width = pct + '%';
        msg.textContent = cart.items_subtotal_price >= threshold
          ? tString('freeShippingUnlocked', 'Congratulations! You\'ve unlocked FREE shipping')
          : tString('spendMore', 'Spend [amount] more to unlock FREE shipping').replace('[amount]', formatMoney(threshold - cart.items_subtotal_price));
      }
    }
  }

  function fetchCart() {
    return fetch(window.theme.routes.cart + '.js')
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () { toast('Something went wrong. Please try again.', true); });
  }

  function bindCartLines(scope) {
    $$('[data-cart-line]', scope).forEach(function (line) {
      var key = line.dataset.key;
      var input = $('[data-qty-input]', line);
      var minus = $('[data-qty-minus]', line);
      var plus = $('[data-qty-plus]', line);
      var removeBtn = $('[data-cart-remove]', line);
      if (minus) minus.addEventListener('click', function () {
        var val = Math.max(0, parseInt(input.value, 10) - 1);
        input.value = val;
        changeLine(key, val);
      });
      if (plus) plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) + 1;
        input.value = val;
        changeLine(key, val);
      });
      if (input) input.addEventListener('change', function () {
        changeLine(key, Math.max(0, parseInt(input.value || '0', 10)));
      });
      if (removeBtn) removeBtn.addEventListener('click', function () {
        changeLine(key, 0);
      });
    });
  }

  if (cartDrawer) {
    trapFocus(cartDrawer);
    $$('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetchCart().then(function () { openOverlay(cartDrawer); });
      });
    });
    $$('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', function () { closeOverlay(cartDrawer); });
    });
    bindCartLines(cartDrawer);
  }

  /* --------------------------- Ajax add to cart --------------------------- */
  doc.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-ajax-cart]')) return;
    if (!window.theme.cartDrawer || !cartDrawer) return;
    e.preventDefault();

    var button = $('[data-add-button]', form) || $('button[type="submit"]', form);
    var originalHtml = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.textContent = tString('adding', 'Adding...'); }

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (res.ok) return res.json();
        return res.json().then(function (err) {
          throw new Error((err.description || err.message || 'Could not add to cart.'));
        });
      })
      .then(function () {
        return fetchCart();
      })
      .then(function () {
        openOverlay(cartDrawer);
        toast(tString('addedToCart', 'Added to cart'));
        if (button) { button.disabled = false; button.innerHTML = originalHtml; }
      })
      .catch(function (err) {
        toast(err.message, true);
        if (button) { button.disabled = false; button.innerHTML = originalHtml; }
      });
  });

  /* ============================ PRODUCT PAGE ================================ */
  var productRoot = $('[data-product-root]');

  if (productRoot) {
    /* Gallery */
    (function gallery() {
      var main = $('[data-gallery-main]');
      var thumbs = $$('[data-gallery-thumb]');
      if (!main || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.dataset.mediaId;
          $$('.product-gallery__slide', main).forEach(function (slide) {
            slide.classList.toggle('is-active', slide.dataset.mediaId === id);
          });
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });

      /* Zoom origin follows the cursor */
      main.addEventListener('mousemove', function (e) {
        var rect = main.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        main.style.setProperty('--zoom-x', x + '%');
        main.style.setProperty('--zoom-y', y + '%');
      });
    })();

    /* Variants */
    (function variants() {
      var jsonEl = $('[data-product-json]');
      if (!jsonEl) return;
      var product;
      try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      var idInput = $('[data-variant-id]', productRoot);
      var priceWrapper = $('[data-price-wrapper]', productRoot);
      var addButton = $('[data-add-button]', productRoot);
      var addButtonText = $('[data-add-button-text]', productRoot);
      var stockBadge = $('[data-stock-badge]', productRoot);
      var inventoryEl = $('[data-inventory]', productRoot);
      var skuEl = $('[data-sku]', productRoot);

      function selectedOptions() {
        var selected = [];
        $$('[data-option-fieldset]', productRoot).forEach(function (fieldset) {
          var pos = parseInt(fieldset.dataset.optionPosition, 10);
          var checked = $('input:checked', fieldset);
          if (!checked) {
            var first = $('input', fieldset);
            if (first) { first.checked = true; checked = first; }
          }
          selected[pos - 1] = checked ? checked.value : null;
        });
        return selected.filter(function (v) { return v !== null && v !== undefined; });
      }

      function findVariant(options) {
        return product.variants.find(function (variant) {
          return variant.options.length === options.length &&
            variant.options.every(function (opt, i) { return opt === options[i]; });
        });
      }

      function updateMedia(variant) {
        if (!variant || !variant.featured_media) return;
        var slide = $('.product-gallery__slide[data-media-id="' + variant.featured_media.id + '"]');
        if (!slide) return;
        $$('.product-gallery__slide').forEach(function (s) { s.classList.toggle('is-active', s === slide); });
        var thumb = $('.product-gallery__thumb[data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) {
          $$('.product-gallery__thumb').forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
          if (thumb.scrollIntoView) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        }
      }

      function update(variant, options) {
        var matched = variant || null;

        if (!matched) {
          if (addButton) { addButton.disabled = true; }
          if (addButtonText) addButtonText.textContent = tString('unavailable', 'Unavailable');
          return;
        }

        if (idInput) idInput.value = matched.id;

        if (priceWrapper) {
          var compare = (matched.compare_at_price && matched.compare_at_price > matched.price)
            ? matched.compare_at_price : null;
          var savePct = compare ? Math.round((compare - matched.price) / compare * 100) : 0;
          var html = '<div class="price' + (compare ? ' price--on-sale' : '') + '">' +
            '<span class="price__current">' + formatMoney(matched.price) + '</span>';
          if (compare) html += '<s class="price__compare">' + formatMoney(compare) + '</s>';
          html += '</div>';
          if (compare) {
            html += '<span class="product-info__save" data-save-text>' + escapeHtml(tString('save', 'Save [amount]').replace('[amount]', formatMoney(compare - matched.price))) + '</span>';
            html += '<span class="badge badge--sale">-' + savePct + '%</span>';
          }
          html += '<span class="product-info__stock' + (matched.available ? '' : ' product-info__stock--out') + '" data-stock-badge>' +
            (matched.available ? tString('inStock', 'In stock') : tString('soldOut', 'Sold out')) + '</span>';
          priceWrapper.innerHTML = html;
        }

        if (inventoryEl) {
          var qty = matched.inventory_quantity;
          if (matched.available && matched.inventory_management && typeof qty === 'number' && qty > 0 && qty <= 10) {
            inventoryEl.textContent = tString('onlyLeft', 'Only [count] left in stock — order soon').replace('[count]', qty);
            inventoryEl.hidden = false;
          } else {
            inventoryEl.hidden = true;
          }
        }

        if (skuEl && matched.sku) skuEl.textContent = tString('sku', 'SKU') + ': ' + matched.sku;

        if (addButton) addButton.disabled = !matched.available;
        if (addButtonText) addButtonText.textContent = matched.available ? tString('addToCart', 'Add to cart') : tString('soldOut', 'Sold out');

        updateMedia(matched);

        if (history.replaceState) {
          var url = window.location.pathname + '?variant=' + matched.id;
          history.replaceState({}, '', url);
        }
      }

      $$('.variant-picker__input', productRoot).forEach(function (input) {
        input.addEventListener('change', function () {
          var options = selectedOptions();
          update(findVariant(options), options);
        });
      });

      /* Initial inventory message for the preselected variant */
      var initial = $('[data-current-variant-json]');
      if (initial && inventoryEl) {
        try {
          var current = JSON.parse(initial.textContent);
          if (current.available && current.inventory_management && typeof current.inventory_quantity === 'number' && current.inventory_quantity > 0 && current.inventory_quantity <= 10) {
            inventoryEl.textContent = tString('onlyLeft', 'Only [count] left in stock — order soon').replace('[count]', current.inventory_quantity);
            inventoryEl.hidden = false;
          }
        } catch (e) {}
      }

      /* Sync the gallery with the preselected (or ?variant=) variant on load */
      if (initial) {
        try { updateMedia(JSON.parse(initial.textContent)); } catch (e) {}
      }
    })();

    /* Tabs */
    (function tabs() {
      var tabsRoot = $('[data-tabs]', productRoot);
      if (!tabsRoot) return;
      $$('[data-tab]', tabsRoot).forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.dataset.tab;
          $$('[data-tab]', tabsRoot).forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          $$('[data-panel]', tabsRoot).forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.panel === key);
          });
        });
      });
    })();
  }

  /* ============================== COUNTDOWN ================================= */
  $$('[data-countdown]').forEach(function (countdown) {
    var endAttr = parseInt(countdown.dataset.end, 10);
    var end;
    if (endAttr && !isNaN(endAttr)) {
      end = endAttr * 1000;
    } else {
      var midnight = new Date();
      midnight.setHours(24, 0, 0, 0);
      end = midnight.getTime();
    }
    if (end < Date.now()) {
      var fixed = new Date(countdown.dataset.end * 1000);
      if (!isNaN(fixed.getTime()) && fixed.getTime() > Date.now()) end = fixed.getTime();
    }

    var dEl = $('[data-cd-days]', countdown);
    var hEl = $('[data-cd-hours]', countdown);
    var mEl = $('[data-cd-mins]', countdown);
    var sEl = $('[data-cd-secs]', countdown);

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = Math.max(0, end - Date.now());
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor(diff % 86400000 / 3600000);
      var mins = Math.floor(diff % 3600000 / 60000);
      var secs = Math.floor(diff % 60000 / 1000);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
      if (diff === 0 && !endAttr) {
        var midnight = new Date();
        midnight.setHours(24, 0, 0, 0);
        end = midnight.getTime();
      }
    }
    tick();
    setInterval(tick, 1000);
  });

  /* =============================== SLIDERS ================================== */
  $$('[data-slider]').forEach(function (slider) {
    var track = $('[data-slider-track]', slider);
    if (!track) return;
    var scope = slider.closest('.section') || doc;
    var prev = $('[data-slider-prev]', scope);
    var next = $('[data-slider-next]', scope);
    var rtl = doc.documentElement.getAttribute('dir') === 'rtl';

    function pageWidth() {
      var slide = $('[data-slider-slide]', track);
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 4;
      var pos = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: (rtl ? 1 : -1) * pageWidth() * 2, behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: (rtl ? -1 : 1) * pageWidth() * 2, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  });

  /* ============================ HERO SLIDESHOW ============================== */
  $$('[data-hero-slider]').forEach(function (root) {
    var slides = $$('[data-hero-slide]', root);
    if (slides.length < 2) return;
    var dots = $$('[data-hero-dot]', root);
    var prev = $('[data-hero-prev]', root);
    var next = $('[data-hero-next]', root);
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var index = 0;
    var timer = null;

    function goTo(n) {
      index = (n + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function play() {
      stop();
      if (!autoplay || reduceMotion || doc.hidden) return;
      timer = setInterval(function () { goTo(index + 1); }, speed);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1); play(); });
    if (next) next.addEventListener('click', function () { goTo(index + 1); play(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-hero-dot'), 10) || 0);
        play();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', play);
    doc.addEventListener('visibilitychange', play);

    play();
  });

  /* =========================== COLLECTION FILTERS =========================== */
  (function collectionFilters() {
    var form = $('[data-filters-form]');
    if (form) {
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"], select')) form.submit();
      });
    }

    var layout = $('.collection-layout');
    var toggle = $('[data-filters-toggle]');
    if (toggle && layout) {
      toggle.addEventListener('click', function () {
        layout.classList.toggle('is-filters-open');
        doc.body.style.overflow = layout.classList.contains('is-filters-open') ? 'hidden' : '';
      });
    }
    $$('[data-filters-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (layout) layout.classList.remove('is-filters-open');
        doc.body.style.overflow = '';
      });
    });
  })();

})();
